import { createRouter, createWebHistory } from 'vue-router'
import Prelevements from '@/pages/Prelevements.vue'
import Recoltes from '@/pages/Recoltes.vue'
import Cultures from '@/pages/Cultures.vue'
import Pilotage from '@/pages/Pilotage.vue'
import History from '@/pages/History.vue'
import Home from '@/pages/Home.vue'
import PBRs from '@/pages/PBRs.vue'
import Strains from '@/pages/Strains.vue'

const routes = [
  { path: '/', component: Home },
  {
    path: '/prelevement',
    component: Prelevements
  },
  {
    path: '/recoltes',
    component: Recoltes
  },
  {
    path: '/cultures',
    component: Cultures
  },
  {
    path: '/history',
    component: History
  },
  {
    path: '/control',
    component: Pilotage
  },
  {
    path: '/pbrs',
    component: PBRs
  },
  {
    path: '/strains',
    component: Strains
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
